import { useNavigate } from 'react-router-dom';

import { ActionStickerCardProps } from '@backrs_ui/common-ui';

import { TOOLS_BACKRS_ASSESSMENTS_SECTION } from './toolsBackrsAssessmentsSection';
import { TOOLS_EXPLORE_OPPORTUNITIES_SECTION } from './toolsExploreOpportunitiesSection';
import { TOOLS_COLLEGE_SECTION, TOOLS_SCORE_JOB_INTERNSHIP_SECTION } from './toolsGetBackedSection';
import { useToolsGuidesSection } from './toolsGuidesSection';

export type ActionStickerCardSection = Readonly<{
  title: string;
  description: string;
  actionStickerCards: ActionStickerCardProps[];
}>;

export type ToolsSectionParams = Readonly<{
  navigate: ReturnType<typeof useNavigate>;
  showBetaFeatures?: boolean;
}>;

export const useGetToolsPageSections = () => {
  const navigate = useNavigate();

  const sectionParams: ToolsSectionParams = { navigate };

  const collegeSolutions = {
    ...TOOLS_COLLEGE_SECTION(sectionParams),
    title: 'College Solutions',
    description: 'Tools to help you choose, apply, and finance your post-secondary journey.',
  };

  const guides = {
    title: 'Guides',
    description: 'In-depth guides to help you navigate key parts of your journey.',
    nuggets: useToolsGuidesSection(),
  };

  const exploratoryTools = {
    title: 'Exploratory Tools',
    description: 'Scroll through hundreds of opportunities and filter them based on your needs.',
    imageCards: TOOLS_EXPLORE_OPPORTUNITIES_SECTION(sectionParams),
  };

  const careerSolutions = {
    ...TOOLS_SCORE_JOB_INTERNSHIP_SECTION(sectionParams),
    title: 'Career Solutions',
    description: 'Enhance your ability to apply and land roles.',
  };

  const backrsAssessments = TOOLS_BACKRS_ASSESSMENTS_SECTION(sectionParams);

  return { collegeSolutions, guides, exploratoryTools, careerSolutions, backrsAssessments };
};
